const fonts = {
    primary: "Roboto",
    element_labels: "Arial",
};

export default fonts;
